angular
    .module('app.controllers')
    .controller(
        'EditUserCtrl',
        function (
            $rootScope,
            $state,
            $translate,
            notify,
            api,
            usersService,
            formValidator,
            areasOptions,
            groupsOptions,
            jobsOptions,
            userStatusOptions,
            userData,
            permissionsList
        ) {
            const vm = this;

            vm.statusOptions = userStatusOptions;
            vm.groupsOptions = groupsOptions;
            vm.areasOptions = areasOptions;
            vm.jobsOptions = jobsOptions;
            vm.permissions = permissionsList;

            // dane użytkowników
            const UserModel = api('users');
            vm.saveUser = () => {
                if (!fv.isValid()) {
                    return;
                }

                const redirectAfterSave = 0 == vm.user.id;
                const info = notify.info($translate.instant('saving'));
                notify.global(1);

                UserModel.save(vm.user.id, vm.user).then(
                    (response) => {
                        vm.user = usersService.transform(response);
                        UserModel.clearCache();

                        info.close();
                        notify.success($translate.instant('saved'));
                        notify.global(0);

                        if (redirectAfterSave) {
                            $state.go('restricted.users_edit', { id: vm.user.id });
                        }

                        $rootScope.$broadcast('edit-panel-ready');
                    },
                    (response) => {
                        info.close();
                        notify.danger($translate.instant(response.error));
                        notify.global(0);
                    }
                );
            };

            vm.setupPhotoUploader = () => {
                vm.photoChanged = 0;

                const settings = {
                    action: '/api/1/users/$/photo'.replace('$', vm.user.id),
                    allow: '*.(jpg|jpeg|gif|png)',
                    filelimit: 1,
                    param: 'photo',
                    single: true,
                    loadstart() {
                        notify.global(1);
                    },
                    progress(percent) {},
                    allcomplete() {
                        notify.global(0);
                        vm.photoChanged++;
                        vm.user.photo = true;
                    },
                };
                UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
            };

            vm.user = userData;
            vm.setupPhotoUploader();

            const fv = formValidator('#UserForm', vm);
        }
    );
